// extracted by mini-css-extract-plugin
module.exports = {"files":"styles_files__35y8H"};